<div class="main-content">
	<div class="container-fluid">
		<div class="page-card card">

			<div class="card-header card-header-{{color}}-6">
				<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> Create User</h4>
				<div class="card-category card-category-actions">
					<button mat-stroked-button (click)="back()">Cancel</button>
					<button mat-raised-button color="primary" class="create-btn"
								[disabled]="loading || !userForm.valid || !systemForm.valid || user.locations.length < 1 || activeStep !== 2"
								(click)="createUser()">
							<mat-spinner *ngIf="loading" diameter="18" strokeWidth="3"></mat-spinner>
							<span *ngIf="!loading">Create User</span>
					</button>
				</div>
			</div>

			<div class="page-body">
				<div class="stepper-col">
					<mat-stepper orientation="vertical" linear (selectionChange)="logStep($event)">

						<!-- Step 1: User Information -->
						<mat-step [stepControl]="userForm">
							<ng-template matStepLabel>User Information</ng-template>
							<form [formGroup]="userForm" class="step-form">
								<mat-form-field appearance="outline" class="field-full">
									<mat-label>Full Name</mat-label>
									<input matInput formControlName="realname">
									<mat-error *ngIf="userForm.get('realname').hasError('required')">Required</mat-error>
								</mat-form-field>

								<div class="field-row">
									<mat-form-field appearance="outline">
										<mat-label>Email Address</mat-label>
										<input matInput type="email" formControlName="email" placeholder="user@example.com">
										<mat-error *ngIf="userForm.get('email').hasError('pattern')">Invalid email</mat-error>
									</mat-form-field>

									<mat-form-field appearance="outline">
										<mat-label>Phone</mat-label>
										<input matInput type="text" (input)="format_phone($event.target)" formControlName="phone" placeholder="(123) 456-7890">
									</mat-form-field>
								</div>

								<mat-form-field appearance="outline" class="field-full">
									<mat-label>User ID</mat-label>
									<input matInput formControlName="userid" placeholder="e.g. jsmith">
									<button mat-icon-button matSuffix type="button" (click)="suggestUseridFromName()" matTooltip="Generate from Full Name" [disabled]="!userForm.get('realname').value">
										<mat-icon>auto_fix_high</mat-icon>
									</button>
									<mat-hint *ngIf="useridTakenSuggest">{{ useridTakenSuggest }}</mat-hint>
									<mat-error *ngIf="userForm.get('userid').hasError('required')">Required</mat-error>
									<mat-error *ngIf="userForm.get('userid').hasError('pattern')">Letters, numbers, - and _ only</mat-error>
									<mat-error *ngIf="userForm.get('userid').hasError('taken')">Already in use. Try "{{ useridTakenSuggest }}"</mat-error>
								</mat-form-field>

								<mat-form-field appearance="outline" class="field-full">
									<mat-label>Password</mat-label>
									<input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
									<button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" matTooltip="{{ hidePassword ? 'Show password' : 'Hide password' }}">
										<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
									</button>
									<button mat-icon-button matSuffix type="button" (click)="generatePassword()" matTooltip="Generate password">
										<mat-icon>vpn_key</mat-icon>
									</button>
									<mat-error *ngIf="userForm.get('password').hasError('required')">Required</mat-error>
								</mat-form-field>
							</form>
							<div class="step-actions">
								<button mat-raised-button color="primary" matStepperNext [disabled]="!userForm.valid">Next</button>
							</div>
						</mat-step>

						<!-- Step 2: System Information -->
						<mat-step [stepControl]="systemForm">
							<ng-template matStepLabel>System Information</ng-template>
							<form [formGroup]="systemForm" class="step-form">

								<div class="field-row">
									<mat-form-field appearance="outline">
										<mat-label>Default Location</mat-label>
										<mat-select formControlName="defaultlocation" (selectionChange)="defaultLocation($event)">
											<mat-option *ngFor="let loc of recs" [value]="loc.loccode">{{ loc.loccode }} – {{ loc.locationname }}</mat-option>
										</mat-select>
										<mat-error>Required</mat-error>
									</mat-form-field>

									<mat-form-field appearance="outline">
										<mat-label>User Group</mat-label>
										<mat-select formControlName="user_group">
											<mat-option *ngFor="let ug of usergroups" [value]="ug.user_group_id">{{ ug.name }}</mat-option>
										</mat-select>
										<mat-error>Required</mat-error>
									</mat-form-field>
								</div>

								<div class="field-row">
									<mat-form-field appearance="outline">
										<mat-label>Access Level</mat-label>
										<mat-select formControlName="fullaccess">
											<mat-option *ngFor="let level of accessLevels" [value]="level.value">{{ level.name }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

								<div class="toggles-row">
									<mat-slide-toggle formControlName="isPOSUser" color="primary">POS User</mat-slide-toggle>
									<mat-slide-toggle formControlName="isSalesman" color="primary">Salesman</mat-slide-toggle>
								</div>

								<mat-form-field *ngIf="systemForm.get('isPOSUser')?.value" appearance="outline" class="field-full">
									<mat-label>Employee Code</mat-label>
									<input matInput placeholder="Employee Code" formControlName="empcode">
									<mat-error *ngIf="systemForm.get('empcode').errors">
										Code "{{ systemForm.get('empcode').value }}" is already in use for {{ empcodes[systemForm.get('empcode').value] | uppercase }}
									</mat-error>
								</mat-form-field>

								<!-- Salesman Section -->
								<div *ngIf="systemForm.get('isSalesman')?.value" class="salesman-section">
									<div class="salesman-grid">
										<div class="salesman-col">
											<p class="subsection-label">Salesman Setup</p>
											<mat-form-field appearance="outline" class="field-full">
												<mat-label>Salesman Code</mat-label>
												<input matInput formControlName="salesman">
												<mat-hint *ngIf="systemForm.get('salesman')?.value">
													<mat-icon inline>info</mat-icon> A new salesman record will be created.
												</mat-hint>
												<mat-error>Required</mat-error>
											</mat-form-field>
											<mat-form-field appearance="outline" class="field-full">
												<mat-label>Commission Rate (%)</mat-label>
												<input matInput type="number" placeholder="e.g. 5.5" formControlName="commissionrate1">
											</mat-form-field>
											<mat-form-field appearance="outline" class="field-full">
												<mat-label>CSR Emails</mat-label>
												<input matInput placeholder="Separate with commas" formControlName="csremails">
											</mat-form-field>
										</div>
										<div class="salesman-col">
											<p class="subsection-label">Telegram Setup</p>
											<mat-form-field appearance="outline" class="field-full">
												<mat-label>Chat ID</mat-label>
												<input matInput placeholder="Optional" formControlName="chatid">
											</mat-form-field>
											<mat-form-field appearance="outline" class="field-full">
												<mat-label>Group ID</mat-label>
												<input matInput type="number" formControlName="group_id">
											</mat-form-field>
											<mat-form-field appearance="outline" class="field-full">
												<mat-label>Group Level</mat-label>
												<input matInput type="number" formControlName="group_level">
											</mat-form-field>
											<mat-form-field appearance="outline" class="field-full">
												<mat-label>Group Type</mat-label>
												<input matInput type="number" formControlName="group_type">
											</mat-form-field>
										</div>
									</div>
								</div>

								<!-- Permissions -->
								<p class="subsection-label">Permissions</p>
								<div class="permissions-grid">
									<ng-container *ngFor="let perm of [
										{ label: 'Customer Admin', name: 'customeradmin' },
										{ label: 'Create Tender', name: 'cancreatetender' },
										{ label: 'Edit Invoice', name: 'editinv' },
										{ label: 'Dispatch Admin', name: 'dispatchadmin' }
									]">
										<mat-form-field appearance="outline">
											<mat-label>{{ perm.label }}</mat-label>
											<mat-select formControlName="{{ perm.name }}">
												<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
											</mat-select>
										</mat-form-field>
									</ng-container>
								</div>
							</form>
							<div class="step-actions">
								<button mat-button matStepperPrevious>Back</button>
								<button mat-raised-button color="primary" matStepperNext [disabled]="!systemForm.valid">Next</button>
							</div>
						</mat-step>

						<!-- Step 3: Location Access -->
						<mat-step>
							<ng-template matStepLabel>Location Access</ng-template>
							<div class="locations-access-grid">
								<div class="location-column">
									<p class="subsection-label">Available</p>
									<mat-nav-list class="loc-list">
										<button mat-list-item *ngFor="let loc of locations" (click)="addUserLocation(loc)">
											<span class="loc-text"><strong>{{ loc.loccode }}</strong> {{ loc.locationname }}</span>
											<mat-icon class="loc-icon" color="primary">add_circle_outline</mat-icon>
										</button>
										<div *ngIf="!locations?.length" class="loc-empty">All locations assigned</div>
									</mat-nav-list>
								</div>
								<div class="location-column">
									<p class="subsection-label">Assigned <span class="loc-count" *ngIf="user.locations?.length">({{ user.locations.length }})</span></p>
									<mat-nav-list class="loc-list">
										<button mat-list-item *ngFor="let loc of user.locations" (click)="removeUserLocation(loc)">
											<span class="loc-text"><strong>{{ loc.loccode }}</strong> {{ loc.locationname }}</span>
											<mat-icon class="loc-icon" color="warn">remove_circle_outline</mat-icon>
										</button>
										<div *ngIf="!user.locations?.length" class="loc-empty">No locations assigned</div>
									</mat-nav-list>
								</div>
							</div>
							<div class="step-actions">
								<button mat-button matStepperPrevious>Back</button>
								<button mat-raised-button color="primary" class="create-btn"
										[disabled]="loading || !userForm.valid || !systemForm.valid || user.locations.length < 1"
										(click)="createUser()">
									<mat-spinner *ngIf="loading" diameter="18" strokeWidth="3"></mat-spinner>
									<span *ngIf="!loading">Create User</span>
								</button>
							</div>
						</mat-step>

					</mat-stepper>
				</div>

				<!-- Review Sidebar -->
				<div class="review-sidebar">
					<div class="review-section">
						<h5 class="review-section-title">User</h5>
						<dl class="review-list">
							<ng-container *ngFor="let field of [
								{ label: 'User ID', key: 'userid' },
								{ label: 'Name', key: 'realname' },
								{ label: 'Email', key: 'email' },
								{ label: 'Phone', key: 'phone' }
							]">
								<dt>{{ field.label }}</dt>
								<dd [class.missing]="!userForm.get(field.key).value"
									[class.error]="userForm.get(field.key).value && userForm.get(field.key).errors">
									{{ userForm.get(field.key).value || '—' }}
								</dd>
							</ng-container>
						</dl>
					</div>

					<div class="review-section">
						<h5 class="review-section-title">System</h5>
						<dl class="review-list">
							<dt>Default Location</dt>
							<dd [class.missing]="!systemForm.get('defaultlocation').value">{{ systemForm.get('defaultlocation').value || '—' }}</dd>
							<dt>Access Level</dt>
							<dd>{{ getAccessLevelName(systemForm.get('fullaccess').value) }}</dd>
							<dt>User Group</dt>
							<dd [class.missing]="!systemForm.get('user_group').value">{{ translate_usergroup(systemForm.get('user_group').value) || '—' }}</dd>
							<dt>Customer Admin</dt>
							<dd>{{ translate_yn(systemForm.get('customeradmin').value) }}</dd>
							<dt>Create Tender</dt>
							<dd>{{ translate_yn(systemForm.get('cancreatetender').value) }}</dd>
							<dt>Edit Invoice</dt>
							<dd>{{ translate_yn(systemForm.get('editinv').value) }}</dd>
							<dt>Dispatch Admin</dt>
							<dd>{{ translate_yn(systemForm.get('dispatchadmin').value) }}</dd>
						</dl>
					</div>

					<div class="review-section">
						<h5 class="review-section-title">
							Locations
							<span class="loc-count" *ngIf="user.locations?.length">({{ user.locations.length }})</span>
						</h5>
						<dl class="review-list" *ngIf="user.locations?.length; else noLocs">
							<ng-container *ngFor="let loc of user.locations">
								<dt>{{ loc.loccode }}</dt>
								<dd>{{ loc.locationname }}</dd>
							</ng-container>
						</dl>
						<ng-template #noLocs>
							<p class="missing review-empty">No locations assigned yet</p>
						</ng-template>
					</div>
				</div>

			</div>
		</div>
	</div>
</div>
